export default __webpack_public_path__ + "static/media/occupied_flag.889f67fc.svg";